import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHeaders, HttpInterceptor, HttpHandler, HttpParams, HttpRequest, HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';

import { IAuthenticationData, IAuthenticationInfo } from '../../../models/models-index';
import { Enums, IEnums } from '../../../enums/enums';

import { Observable, throwError } from 'rxjs';
import { AppInsightsService } from '../../appInsights/appInsights.service';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../authentication.service';
import { environment } from '../../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationInterceptorService implements HttpInterceptor {
  private enums: IEnums = Enums;
  private user: IAuthenticationInfo;


  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private appInsights: AppInsightsService) {
  }

  //TODO: Add error handling for 401 and refresh tokens
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.applyCredentials(request))
      .pipe(
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse && err.status === 401) {
            localStorage.removeItem('user');
            console.error('Http Error', err);
            !!environment.loginRedirectUrl ? window.location.href = environment.loginRedirectUrl : this.router.navigateByUrl('/login');
          } else {
            this.appInsights.trackException(err);
            return throwError(() => err);
          }
        })
      );
  }

  private applyCredentials(request: HttpRequest<any>) {

    this.user = this.authService.getUser();

    if (this.user) {
      let headers: HttpHeaders;
      // Pass the existing request headers to setHttpHeaders
      if (request.body instanceof FormData) {
        headers = this.setHttpHeaders(this.user, request.headers, false);
      } else {
        headers = this.setHttpHeaders(this.user, request.headers);
      }
      request = request.clone({ headers: headers/*, withCredentials: true*/ });
    }
    return request;
  }

  private setHttpHeaders(user: IAuthenticationInfo, existingHeaders: HttpHeaders = null, setContentType = true) {
    let myHeaders = existingHeaders || new HttpHeaders();

    // Only set headers if they're not already present
    if (!myHeaders.has('Access-Control-Allow-Origin')) {
      myHeaders = myHeaders.set('Access-Control-Allow-Origin', '*');
    }

    if (!myHeaders.has('Access-Control-Allow-Credentials')) {
      myHeaders = myHeaders.set('Access-Control-Allow-Credentials', 'true');
    }

    if (!myHeaders.has('Accept')) {
      myHeaders = myHeaders.set('Accept', 'application/json');
    }

    if (!myHeaders.has('X-Auth-Token')) {
      myHeaders = myHeaders.set('X-Auth-Token', user.token);
    }

    if (!myHeaders.has('Authorization')) {
      myHeaders = myHeaders.set('Authorization', 'Bearer ' + user.token);
    }

    // Only set Content-Type if specified and not already present
    if (setContentType && !myHeaders.has('Content-Type')) {
      myHeaders = myHeaders.set('Content-Type', 'application/json');
    }

    return myHeaders;
  }

  private setDownloadHttpHeaders(authData: IAuthenticationData) {
    const myHeaders = new HttpHeaders()
      .set('Content-Type', 'text/csv')
      .set('Accept', 'text/csv')
      .set('X-Auth-Token', authData.token)
      .set('Authorization', 'Bearer ' + authData.token);

    return myHeaders;
  }

  private setUploadHttpHeaders(authData: IAuthenticationData) {
    const myHeaders = new HttpHeaders()
      .set('X-Auth-Token', authData.token)
      .set('Authorization', 'Bearer ' + authData.token);

    return myHeaders;
  }

  private trackException(exception: any) {
    // this.ai.trackException(exception);
  }
}
